export class objUsuarioModel{
    id_cia:number = 0;
    coduser: string = '';
    nombres: string= '';
    cargo: string = '';
    clave: string = '';
    nuevaclave:string= '';
    ruc: string = '';
    codsuc: number = 0 ;
    atributos:number = 0 ;
    fexpira: Date = null;
    fcreac: Date =null;
    factua: Date = null;
    comentario: string = '';
    impeti:number = 0 ;
    activo : boolean = true;
    usuari: string = '';
    numcaja: number = 0;
    propiedad = new  UsuarioPropiedadesFrm();
} 

export class UsuarioPropiedadesFrm {
     modificar: boolean = false;
     eliminar: boolean = false;
     exportaDocumentos: boolean = false;
     visarCotizacion: boolean = false;
     enviarKardex: boolean = false;
     enviarCtes: boolean = false;
     anular: boolean = false;
     anularCotizacion: boolean = false;
     anularOrdenPedido: boolean = false;
     anularGuiaRemision: boolean = false;
     anularComprobanteVenta: boolean = false;
     anularGuiaRecepcion: boolean = false;
     usaPeriodofijo: boolean = false;
     visarOrdenpedido: boolean = false;
     visarRequerimientocompra: boolean = false;
     visarOrdencompra: boolean = false;
     visarOrdenproduccion: boolean = false;
     aprobarOrdenpedido: boolean = false;
     visarOrdendevolucion: boolean = false;
     codigoVendedor: number ;
     desentregarGuiaRecepcion: boolean = false;
}
